import axios from 'axios';
import { API_BASE_URL } from './routes';

const http = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,  // 启用跨域请求时发送凭证
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  timeout: 10000  // 设置超时时间为10秒
});

// 请求拦截器：添加token
http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // 确保每个请求都带上这些头
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  },
  (error) => {
    console.error('请求拦截器错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器：处理token过期和错误
http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // 处理CORS错误
    if (error.message === 'Network Error' || error.code === 'ERR_NETWORK') {
      console.error('CORS或网络错误:', error);
      return Promise.reject(new Error('网络连接失败，请检查网络设置或联系管理员'));
    }
    
    // 处理401错误（未授权）
    if (error.response?.status === 401 && !originalRequest._retry && !originalRequest.url?.includes('/auth/refresh-token')) {
      originalRequest._retry = true;
      
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
          localStorage.removeItem('token');
          localStorage.removeItem('refresh_token');
          return Promise.reject(new Error('登录已过期，请重新登录'));
        }
        
        const response = await http.post('/auth/refresh-token', { refresh_token: refreshToken });
        const { access_token, refresh_token } = response.data;
        
        localStorage.setItem('token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        
        http.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        originalRequest.headers['Authorization'] = `Bearer ${access_token}`;
        
        return http(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        return Promise.reject(new Error('刷新令牌失败，请重新登录'));
      }
    }
    
    // 处理500错误（服务器错误）
    if (error.response?.status === 500) {
      console.error('服务器错误:', error.response.data);
      return Promise.reject(new Error('服务器出现错误，请稍后重试'));
    }
    
    return Promise.reject(error);
  }
);

export default http; 